(function () {
    'use strict';

    angular
        .module('emails')
        .controller('AudienceController', AudienceController);

    AudienceController.$inject = ['$scope','$uibModal','$compile','CampaignsService','toastr','AudienceService'];

    function AudienceController($scope,$uibModal,$compile,CampaignsService,toastr,AudienceService) {
        var vm = this;

        /*PAGINATION*/
        vm.pageChanged            = pageChanged;
        vm.setPage                = setPage;
        vm.totalItems             = 0;
        vm.to                     = [];
        vm.currentPage            = null;
        vm.itemsPerPage           = [];
        vm.page                   = 1;

        vm.query                  = {};
        vm.audiences              = [];
        vm.title                  = "";
        vm.getByFilter            = getByFilter;
        vm.flag                   = false;
        vm.formatDate             = formatDate;
        vm.getAll                 = getAll;
        vm.removeAudience         = removeAudience;

        function activate(){
            vm.getAll();
        }

        function getAll() {
            var query =[];
            query['page'] = vm.page;
            AudienceService.getAllAudiences(query).then(function(response){
                if(response.data.data.length) {
                    vm.flag = true;
                }
                vm.audiences = response.data.data;
                vm.totalItems = response.data.total;
                vm.itemsPerPage = response.data.per_page;
                vm.setPage(response.data.current_page);
            }).catch(function(err) {
            });
        }

        function getByFilter() {
            vm.flag = false;
            vm.query = [];
            vm.query['title'] = vm.title;
            AudienceService.getAudiences(vm.query).then(function(response){
                if(response.data.data.length) {
                    vm.flag = true;
                }
                vm.audiences = response.data.data;
                vm.totalItems = response.data.total;
                vm.itemsPerPage = response.data.per_page;
                vm.setPage(response.data.current_page);
            }).catch(function(err) {
            });
        }

        function removeAudience(audience) {
            $uibModal.open({
                templateUrl: 'templates/emails/audience/deleteAudience/template.modal.html',
                controller: 'deleteAudienceController',
                controllerAs:'DeleteAudience',
                resolve:
                    {
                        audience : function () {
                            return audience;
                        },
                        audienceList  : function () {
                            return vm.audiences;
                        }
                    }
            });

        }

        function formatDate(date){
            return new Date(date);
        }

        /* Pagination */
        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }
        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            vm.getAll();
        }

        activate();
    }

})();